import { createAction } from "@ngrx/store";

export const init = createAction("[Room V2] Init");
export const destroy = createAction("[Room V2] Destroy");
